module.exports = __webpack_public_path__ + "img/switzerland-colorectal-cancer-female.cf2f6470.png";